import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import styles from "./BranchCard.module.css";

export default function BranchCard({ branch }) {
  const [isOpen, setIsOpen] = useState(false);
  const [qrImage, setQrImage] = useState(null);
  const [qrLoading, setQrLoading] = useState(false);
  const [qrError, setQrError] = useState(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("tr-TR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (!isOpen || !branch?.id) return;
    setQrLoading(true);
    setQrError(null);
    setQrImage(null);
    api
      .get(`/api/appointments/qr/${branch.id}`)
      .then((response) => {
        // API: { success, message, data: { qrCode, branch, departments, qrData } }
        const qrCode = response.data?.data?.qrCode;
        if (qrCode && typeof qrCode === "string") {
          setQrImage(
            qrCode.startsWith("data:")
              ? qrCode
              : `data:image/png;base64,${qrCode}`,
          );
        }
      })
      .catch((err) => {
        setQrError(err.response?.data?.message || "QR kod yüklenemedi.");
      })
      .finally(() => {
        setQrLoading(false);
      });
  }, [isOpen, branch?.id]);

  return (
    <div className={styles.branchCard}>
      <div className={styles.branchHeader} onClick={toggleOpen}>
        <div className={styles.headerContent}>
          <h4 className={styles.branchName}>{branch.name}</h4>
          <span className={styles.departmentCount}>
            {branch.departmentCount} Departman
          </span>
        </div>
        <span className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ""}`}>
          ▼
        </span>
      </div>
      {isOpen && (
        <div className={styles.branchDetailsContainer}>
          <div className={styles.branchDetails}>
            <div className={styles.detailItem}>
              <span className={styles.label}>Adres:</span>
              <span className={styles.value}>{branch.address}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>Telefon:</span>
              <span className={styles.value}>{branch.phone}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>Oluşturulma:</span>
              <span className={styles.value}>
                {formatDate(branch.createdAt)}
              </span>
            </div>
          </div>
          <div className={styles.qrCode}>
            {qrLoading && (
              <span className={styles.qrLoading}>QR kod yükleniyor...</span>
            )}
            {qrError && <span className={styles.qrError}>{qrError}</span>}
            {qrImage && !qrLoading && (
              <img
                src={qrImage}
                alt={`${branch.name} randevu QR kodu`}
                className={styles.qrImage}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
